import { useCallback, useEffect, useRef } from 'react';
import _throttle from 'lodash.throttle';

function useOnInitialHeaderTransitionsEnded(element: HTMLElement | null, callback: () => void) {
  const transitionsCounts = useRef(0);

  function cleanupTransitionEvents() {
    element?.removeEventListener('transitionstart', onTransitionStart);
    element?.removeEventListener('transitionend', onTransitionEnded);
  }

  const onScroll = _throttle(() => {
    cleanupTransitionEvents();
    document.removeEventListener('scroll', onScroll);
  }, 20);

  const onTransitionStart = useCallback(() => {
    transitionsCounts.current += 1;
  }, []);

  const onTransitionEnded = useCallback(() => {
    transitionsCounts.current -= 1;

    if (transitionsCounts.current === 0) {
      callback();
      cleanupTransitionEvents();
    }
  }, []);

  useEffect(() => {
    callback();

    document.addEventListener('scroll', onScroll);

    element?.addEventListener('transitionstart', onTransitionStart);
    element?.addEventListener('transitionend', onTransitionEnded);

    return () => {
      cleanupTransitionEvents();
      document.removeEventListener('scroll', onScroll);
    };
  }, [element, onTransitionEnded, onTransitionStart]);
}

export default useOnInitialHeaderTransitionsEnded;
